import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import { IconButton, Typography } from "@mui/material";
import { Box } from "@mui/system";
import toast from "react-hot-toast";

const TOAST_ID = "scan-toast";
const TOAST_DURATION = 3000;

export const errorToast = (message: string) => {
  toast.custom(
    (t) => (
      <Box
        sx={{ backgroundColor: "#FCEDEC", borderRadius: 1, p: 1 }}
        display="flex"
        alignItems="center"
      >
        <ErrorOutlineOutlinedIcon color="error" />
        <Typography color="#602120" pl={1}>
          {message}
        </Typography>
        <IconButton size="small" onClick={() => toast.remove(t.id)}>
          <CloseRoundedIcon fontSize="small" />
        </IconButton>
      </Box>
    ),
    {
      duration: TOAST_DURATION,
      id: TOAST_ID,
    },
  );
};

export const warningToast = (message: string) => {
  toast.custom(
    (t) => (
      <Box
        sx={{ backgroundColor: "#FEF4E5", borderRadius: 1, p: 1 }}
        display="flex"
        alignItems="center"
      >
        <ErrorOutlineOutlinedIcon color="warning" />
        <Typography color="#663D00" pl={1}>
          {message}
        </Typography>
        <IconButton size="small" onClick={() => toast.remove(t.id)}>
          <CloseRoundedIcon fontSize="small" />
        </IconButton>
      </Box>
    ),
    {
      duration: TOAST_DURATION,
      id: TOAST_ID,
    },
  );
};

export const infoToast = (message: string) => {
  toast.custom(
    (t) => (
      <Box
        sx={{ backgroundColor: "#E5F5FD", borderRadius: 1, p: 1 }}
        display="flex"
        alignItems="center"
      >
        <ErrorOutlineOutlinedIcon color="info" />
        <Typography color="#004360" pl={1}>
          {message}
        </Typography>
        <IconButton size="small" onClick={() => toast.remove(t.id)}>
          <CloseRoundedIcon fontSize="small" />
        </IconButton>
      </Box>
    ),
    {
      duration: TOAST_DURATION,
      id: TOAST_ID,
    },
  );
};

export const successToast = (message: string) => {
  toast.custom(
    (t) => (
      <Box
        sx={{ backgroundColor: "#EDF7ED", borderRadius: 1, p: 1 }}
        display="flex"
        alignItems="center"
      >
        <ErrorOutlineOutlinedIcon color="success" />
        <Typography color="#1D4620" pl={1}>
          {message}
        </Typography>
        <IconButton size="small" onClick={() => toast.remove(t.id)}>
          <CloseRoundedIcon fontSize="small" />
        </IconButton>
      </Box>
    ),
    {
      duration: TOAST_DURATION,
      id: TOAST_ID,
    },
  );
};
